<ul class="dvb-module-list popover-list">
    <li ng-repeat="modul in vm.modules"><span translate="MANDANT.MODULE.{{modul}}"></span></li>
</ul>
